'use strict';

var _ = require('lodash');
var ConstraintValidationDirective = function ConstraintValidationDirective(constraintValidationService, $rootScope, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ngModel) {
      var isValid = function isValid(value) {
        return constraintValidationService.validate(value, scope.constraint, scope.allActions);
      };
      var isVisible = function isVisible() {
        return ele.is(':visible');
      };
      ngModel.$validators.constraintValidation = function (modelValue, viewValue) {
        if (!isVisible()) {
          return true;
        }
        if (scope.constraint) {
          var value = modelValue || viewValue;
          var valid = isValid(value);
          var constraintField = _.findLast(scope.allActions, ['field', scope.constraint.field]);
          if (valid && constraintField) {
            $rootScope.$broadcast('rules:reValidateConstraints');
          }
          return valid;
        } else {
          return true;
        }
      };
      scope.$on('rules:reValidateConstraints', function () {
        if (ngModel.$invalid) {
          $timeout(function () {
            ngModel.$$parseAndValidate();
          }, 0);
        }
      });
    }
  };
};
ConstraintValidationDirective.$inject = ['ConstraintValidationService', '$rootScope', '$timeout'];
module.exports = ConstraintValidationDirective;